"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialActionArrowDown = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const triangle_arrow_1 = require("../arrows/triangle-arrow");
exports.SpecialActionArrowDown = (0, styled_components_1.default)(triangle_arrow_1.TriangleArrow) `
  position: absolute;
  top: 42%;
  right: 5px;
`;
//# sourceMappingURL=special-action-arrow-down.js.map